import AddType from "../scripts/AddType";
import AlertType from "../scripts/AlertType";
import CallApiType from "../scripts/CallApiType";
import ConditionType from "../scripts/ConditionType";
import ConfirmType from "../scripts/ConfirmType";
import DeleteDataType from "../scripts/DeleteDataType";
import DeleteType from "../scripts/DeleteType";
import DisableType from "../scripts/DisableType";
import EditType from "../scripts/EditType";
import EnableType from "../scripts/EnableType";
import EndType from "../scripts/EndType";
import GetDataType from "../scripts/GetDataType";
import GetLocationType from "../scripts/GetLocationType";
import GoBackType from "../scripts/GoBackType";
import GoHomeType from "../scripts/GoHomeType";
import GoPageType from "../scripts/GoPageType";
import HideType from "../scripts/HideType";
import InsertDataType from "../scripts/InsertDataType";
import LoginType from "../scripts/LoginType";
import LogoffType from "../scripts/LogoffType";
import MessageType from "../scripts/MessageType";
import OpenURLType from "../scripts/OpenURLType";
import RunWorkflowType from "../scripts/RunWorkflowType";
import SaveType from "../scripts/SaveType";
import SetModelType from "../scripts/SetModelType";
import ShowType from "../scripts/ShowType";
import UpdateDataType from "../scripts/UpdateDataType";
import RefreshType from "../scripts/RefreshType";
import ExportDataType from "../scripts/ExportDataType";
import DownloadFileType from "../scripts/DownloadFileType.js";
import RefreshCurrentType from "../scripts/RefreshCurrentType.js";

export default [{
        title: "General",
        types: [AlertType, ConditionType, ConfirmType, EndType, LoginType, LogoffType, MessageType]
    },
    {
        title: "Component",
        types: [AddType, DeleteType, DisableType, EditType, EnableType, HideType, RefreshType, RefreshCurrentType, SaveType, ShowType],
    },
    {
        title: "Data",
        types: [CallApiType, DeleteDataType, GetDataType, GetLocationType, InsertDataType, RunWorkflowType, SetModelType, UpdateDataType, ExportDataType]
    }, {
        title: "Navigation",
        types: [GoBackType, GoHomeType, GoPageType, OpenURLType, DownloadFileType]
    }
]